<template>
  <div v-if="alwaysShow || total > pageSize" class="app-pagination">
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      :pager-count="5"
      :disabled="loading"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 12 },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    alwaysShow: { type: Boolean, default: false }
  },
  methods: {
    handlePageChange(page) {
      if (!this.loading && page !== this.page) this.$emit('change', page)
    }
  }
}
</script>

<style scoped>
.app-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .app-pagination {
    max-width: 100%;
    overflow: hidden;
  }
  .app-pagination ::v-deep .el-pagination {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 0;
  }
  .app-pagination ::v-deep .btn-prev,
  .app-pagination ::v-deep .btn-next,
  .app-pagination ::v-deep .el-pager li {
    min-width: 44px;
    height: 44px;
    margin: 0 1px;
    line-height: 44px;
  }
}

@media (max-width: 360px) {
  .app-pagination ::v-deep .el-pager li.more {
    display: none;
  }
}
</style>
